import Layout from '../components/layout'
import Meta from '../components/meta'
import tw, { css } from 'twin.macro'
import { navigate } from 'gatsby'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import '../components/fonts/flexo.css'

const FocusChemcials = props => {
    // The state for the overlay is no longer needed since it's being replaced.
    // const [registerOverlay, setRegisterOverlay] = useState(false)
    const {
        FocusHeroBannerImage,
        FocusChemicalsTextImage,
        SwimMoreWorkLessLogo,
        MaytronicsFocusLogo,
        FocusAlgaecideTile,
        FocusBalancersTile,
        FocusWaterEnhancersTile,
        FocusOxidisersTile,
        FocusCleanersTile,
        FocusSanitisersTile,
        FocusLiquaTile
    } = props.data

    return (
        <div>
            <Layout>
                <Meta
                    title="Quality Swimming Pool Chemicals in Australia | Focus Products"
                    keywords={[
                        'pool chemicals',
                        'swimming pool chemicals',
                        'pool chemicals australia'
                    ]}
                    description="Focus Products offers a complete range of premium swimming pool chemicals in Australia, including sanitisers, balancers and oxidisers designed to maintain sparkling, healthy pool water."
                />

                {/* Tracking Script */}
                <script
                    type="application/javascript"
                    dangerouslySetInnerHTML={{
                        __html: `(function(w,d,t,r,u){w[u]=w[u]||[];w[u].push({'projectId':'10000','properties':{'pixelId':'10206112','he': '<email_address>','hph': '<phone_number>'}});var s=d.createElement(t);s.src=r;s.async=true;s.onload=s.onreadystatechange=function(){var y,rs=this.readyState,c=w[u];if(rs&&rs!="complete"&&rs!="loaded"){return}try{y=YAHOO.ywa.I13N.fireBeacon;w[u]=[];w[u].push=function(p){y([p])};y(c)}catch(e){}};var scr=d.getElementsByTagName(t)[0],par=scr.parentNode;par.insertBefore(s,scr)})(window,document,"script","https://s.yimg.com/wi/ytc.js","dotq");`,
                    }}
                />

                {/* Hero Image Section */}
                <div css={[tw`relative w-full overflow-hidden`, { height: '85vh' }]}>
                    <Img
                        fluid={FocusHeroBannerImage.nodes[0].fluid}
                        alt={FocusHeroBannerImage.nodes[0].alt || FocusHeroBannerImage.nodes[0].title}
                        css={[
                            tw`w-full h-full`,
                            css`
                                img {
                                    object-fit: cover !important;
                                }
                            `,
                        ]}
                    />

                    {/* Top Left - Focus Chemicals Text Image */}
                    <div css={[
                        tw`absolute inset-y-0 left-10 md:left-16 lg:left-20 flex flex-col justify-center items-start gap-4`,
                    ]}>
                        <Img
                            {...FocusChemicalsTextImage.nodes[0]}
                            loading="lazy"
                            css={[tw`w-64 md:w-96 lg:w-[32rem]`]}
                        />
                        <button
                            css={[
                                tw`px-12 py-4 bg-white text-lg text-black font-bold rounded-full hover:bg-gray-100 transition-colors duration-200 shadow-lg whitespace-nowrap`,
                            ]}
                            onClick={() => navigate('https://www.focusproducts.com.au/chemicals')}
                        >
                            Explore the Range
                        </button>
                    </div>

                    {/* Bottom Right - Swim More Work Less Logo */}
                    <div css={[tw`absolute bottom-12 right-10 md:right-16 lg:right-20`]}>
                        <Img
                            {...SwimMoreWorkLessLogo.nodes[0]}
                            loading="lazy"
                            css={[tw`w-36 md:w-48 lg:w-64`]}
                        />
                    </div>
                </div>


                {/* Swim More Work Less section */}
                <div
                    css={[
                        tw`text-left px-4 pt-8 pb-2 md:pt-12 md:pb-3 lg:pt-16 lg:pb-4 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    {/* Grid Container - 2 columns, 1 row */}
                    <div
                        css={[
                            tw`grid grid-cols-2 gap-x-4 mt-8 max-w-6xl mx-auto`,
                        ]}
                    >
                        {/* Grid Item 1 */}
                        <div css={[tw`items-start text-left`]}>
                            <h1 css={[tw`font-black text-2xl text-black md:text-3xl lg:text-4xl`]}>
                                <span css={[tw``, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                                Swim More. <br /> Work Less. 
                                </span>
                            </h1>
                            
                        </div>
                        {/* Grid Item 2 - Focus Logo Image */}
                        <div css={[tw`hidden md:flex md:items-center md:ml-auto`]} >
                            <Img
                                {...MaytronicsFocusLogo.nodes[0]}
                                loading="lazy"
                                css={[tw`w-56 md:w-64 lg:w-80 mx-auto md:mx-0`]}
                            />
                        </div>

                    </div>
                    
                    <p
                        css={[
                            tw`mt-3 mx-auto text-left text-black text-base md:text-lg font-semibold`
                        ]}
                    >
                        {' '}
                        Focus is synonymous with outstanding pool chemicals for the Australian climate. From a product of the imagination to the end result, 
                        Focus takes quality and efficiency to the next level. Any pool problem can find its solution within the Focus range of innovative 
                        products. This is further enhanced by the constant involvement of the Focus R&D team and their inquisitive approach. Can it be 
                        better? If so, how? When? Where? This means that every time you use a Focus chemical in your customers&apos; pool, you do so with 
                        confidence. Focus unique formulas are tried, tested and proven to work!
                    </p>
                    
                </div>

                {/* Pool & Spa Chemicals */}

                <div
                    css={[
                        tw`text-center px-4 pt-8 pb-4 md:pt-12 md:pb-8 lg:pt-16 lg:pb-12 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    <h1 css={[tw`font-black text-2xl text-black md:text-3xl lg:text-4xl`]}>
                        <span css={[tw`ml-2 md:ml-4 lg:ml-6`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                            Pool & Spa Chemicals
                        </span>
                    </h1>

                    {/* Tiles Grid */}
                    <div css={[tw`grid grid-cols-1 md:grid-cols-3 gap-4 mt-8`]}>

                        {/* Algaecides */}
                        <div css={[tw`relative rounded-2xl overflow-hidden`]}>
                            <Img
                                {...FocusAlgaecideTile.nodes[0]}
                                loading="lazy"
                                css={[tw`w-full h-full`]}
                            />
                            <div css={[tw`absolute left-1/2`, { transform: 'translateX(-50%)', top: '24%' }]}>
                                <button
                                    css={[tw`px-4 py-1 bg-transparent text-white font-bold rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors duration-200 whitespace-nowrap text-xs`]}
                                    onClick={() => navigate('https://www.focusproducts.com.au/chemicals#h.xjgr872b1j8x_l')}
                                >
                                    Learn More →
                                </button>
                            </div>
                        </div>

                        {/* Balancers */}
                        <div css={[tw`relative rounded-2xl overflow-hidden`]}>
                            <Img
                                {...FocusBalancersTile.nodes[0]}
                                loading="lazy"
                                css={[tw`w-full h-full`]}
                            />
                            <div css={[tw`absolute left-1/2`, { transform: 'translateX(-50%)', top: '24%' }]}>
                                <button
                                    css={[tw`px-4 py-1 bg-transparent text-white font-bold rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors duration-200 whitespace-nowrap text-xs`]}
                                    onClick={() => navigate('https://www.focusproducts.com.au/chemicals#h.clfbn0mtqe5y_l')}
                                >
                                    Learn More →
                                </button>
                            </div>
                        </div>

                        {/* Water Enhancers */}
                        <div css={[tw`relative rounded-2xl overflow-hidden`]}>
                            <Img
                                {...FocusWaterEnhancersTile.nodes[0]}
                                loading="lazy"
                                css={[tw`w-full h-full`]}
                                imgStyle={{ objectFit: 'contain' }}
                            />
                            <div css={[tw`absolute left-1/2`, { transform: 'translateX(-50%)', top: '24%' }]}>
                                <button
                                    css={[tw`px-4 py-1 bg-transparent text-white font-bold rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors duration-200 whitespace-nowrap text-xs`]}
                                    onClick={() => navigate('https://www.focusproducts.com.au/chemicals#h.fkfzlwce0ffg_l')}
                                >
                                    Learn More →
                                </button>
                            </div>
                        </div>

                        {/* Oxidisers */}
                        <div css={[tw`relative rounded-2xl overflow-hidden`]}>
                            <Img
                                {...FocusOxidisersTile.nodes[0]}
                                loading="lazy"
                                css={[tw`w-full h-full`]}
                            />
                            <div css={[tw`absolute left-1/2`, { transform: 'translateX(-50%)', top: '24%' }]}>
                                <button
                                    css={[tw`px-4 py-1 bg-transparent text-white font-bold rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors duration-200 whitespace-nowrap text-xs`]}
                                    onClick={() => navigate('https://www.focusproducts.com.au/chemicals#h.eifbo12fj2im_l')}
                                >
                                    Learn More →
                                </button>
                            </div>
                        </div>

                        {/* Cleaners */}
                        <div css={[tw`relative rounded-2xl overflow-hidden`]}>
                            <Img
                                {...FocusCleanersTile.nodes[0]}
                                loading="lazy"
                                css={[tw`w-full h-full`]}
                            />
                            <div css={[tw`absolute left-1/2`, { transform: 'translateX(-50%)', top: '24%' }]}>
                                <button
                                    css={[tw`px-4 py-1 bg-transparent text-white font-bold rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors duration-200 whitespace-nowrap text-xs`]}
                                    onClick={() => navigate('https://www.focusproducts.com.au/chemicals#h.d8l362ke0bvk_l')}
                                >
                                    Learn More →
                                </button>
                            </div>
                        </div>

                        {/* Sanitisers */}
                        <div css={[tw`relative rounded-2xl overflow-hidden`]}>
                            <Img
                                {...FocusSanitisersTile.nodes[0]}
                                loading="lazy"
                                css={[tw`w-full h-full`]}
                            />
                            <div css={[tw`absolute left-1/2`, { transform: 'translateX(-50%)', top: '24%' }]}>
                                <button
                                    css={[tw`px-4 py-1 bg-transparent text-white font-bold rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors duration-200 whitespace-nowrap text-xs`]}
                                    onClick={() => navigate('https://www.focusproducts.com.au/chemicals#h.4brbmt21r9zc_l')}
                                >
                                    Learn More →
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Liqua AI Smarter*/}
                <div
                    css={[
                        tw`text-center px-4 pt-8 pb-4 md:pt-12 md:pb-8 lg:pt-16 lg:pb-12 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    <h1 css={[tw`font-black text-2xl text-black md:text-3xl lg:text-4xl`]}>
                        <span css={[tw`ml-2 md:ml-4 lg:ml-6`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                            Liqua AI
                        </span>
                    </h1>
                    
                    <p
                        css={[
                            tw`mt-3 mx-auto text-center text-black text-base md:text-lg font-semibold`
                        ]}
                    >
                        {' '}
                        Liqua allows businesses to free themselves from the increasing burden of dealing with 
                        complex in-house technology and managing expensive on-site equipment
                    </p>

                    {/* Image section */}
                    <div css={[tw`text-center mt-6`]}>
                        <a href="https://www.focusproducts.com.au/technology">
                            <Img
                                {...FocusLiquaTile.nodes[0]}
                                loading="lazy"
                                css={[
                                    tw`w-full mx-auto rounded-3xl cursor-pointer`,
                                ]}
                            />
                        </a>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

/**
 * Page content query
 * @private
 * @static
 * @returns {() => void}
 */
export const FocusChemcialsPageQuery = graphql`
	query FocusChemcialsPageQuery {
        FocusHeroBannerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3gAW1v1Oy0RraruoOkLrMh" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				svg: file {
					url
					contentType
				}
				fluid(maxWidth: 2000, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusChemicalsTextImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2DqFgC2Q6WT3mLYkg3bvdU" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        SwimMoreWorkLessLogo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4gjoVmWfjy45O18lEFngKq" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        MaytronicsFocusLogo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3xvts7FG01gMXFc8kRaSXA" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusAlgaecideTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4dWD7ePLBMAFSWoCDXINc" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusBalancersTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4odbGbVo6ulrmLc4TAwDbo" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusWaterEnhancersTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "7G2GiYYRicwuVcV9KlRLXs" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusOxidisersTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6cxF94XniIMCFbdVhb4Sqp" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusCleanersTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3PsMf4T8Zrajv1NvrQtWlQ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusSanitisersTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4CGFfhynyWQBfvJWORgkVg" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        FocusLiquaTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5BsLXCxcYtosTO4kajMyZh" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
	}
`

FocusChemcials.propTypes = {
    props: PropTypes.shape({
        data: PropTypes.shape({
            FocusHeroBannerImage: PropTypes.object,
            FocusChemicalsTextImage: PropTypes.object,
            SwimMoreWorkLessLogo: PropTypes.object,
            MaytronicsFocusLogo: PropTypes.object,
            FocusAlgaecideTile: PropTypes.object,
            FocusBalancersTile: PropTypes.object,
            FocusWaterEnhancersTile: PropTypes.object,
            FocusOxidisersTile: PropTypes.object,
            FocusCleanersTile: PropTypes.object,
            FocusSanitisersTile: PropTypes.object,
            FocusLiquaTile: PropTypes.object
        }),
    }),
}
export default FocusChemcials
